import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransitionGroup } from 'react-transition-group';
import FlatButton from 'material-ui/FlatButton';
import Paper from 'material-ui/Paper';
import OriginIcon from 'material-ui/svg-icons/maps/my-location';
import PerimeterIcon from '../../../icons/Polygon';

import EditOriginToolbar from './EditOriginToolbar';
import EditPerimeterToolbar from './EditPerimeterToolbar';
import debounce from 'lodash/debounce';
import * as esriLoader from 'esri-loader';

import { setOriginSelectionGraphics,
  enableDrawMode, disableDrawMode, pauseDrawMode, resumeDrawMode, setUploadPolygonGeometry, setModifiedPerimeter,
  setPerimeterSymbology, isOriginWithinPerimeter, clearModifiedPerimeter, setMapViewTarget, clearVisiblePerimeters, completeDrawUpdate
 } from '../../esri/mapHub';

import symbols from '../../../defaults/Symbols.json';

import './EditGeometryToolbar.css';

const paperStyle = {
  borderRadius: "0 0 2px 2px"
}

class EditGeometryToolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      geometryField: null, // null (selector ui), "ORIGIN", "PERIMETER"
      confirmDisabled: true,
      latitude: this.props.incident.attributes["y"],
      longitude: this.props.incident.attributes["x"],
      originWithinPerimeter: this.props.originWithinPerimeter,
      modifiedPerimeterGeometry: null,
    };
  }

  editWasCancelled = () =>
  {
    this.cancelPerimeterEdit();
    this.cancelOriginEdit();
  }

  setGeometryFieldState = (geometryField) => {

    this.setState({
      geometryField: geometryField,
        confirmDisabled: true
    });
    if(geometryField === "ORIGIN")
    {
      this.enableOriginDraw();
    }
    else if (geometryField ==="PERIMETER")
    {
      if (this.props.perimeter === null || this.props.perimeter === undefined)
      {
        enableDrawMode({drawAction: "polygon", geometry: null, enableSketchOnDrawComplete: true}).then((args) =>
        {
          this.setState(
            {
              confirmDisabled: false,
              modifiedPerimeterGeometry: args.geometry
            }
          );

          setModifiedPerimeter({
            graphics: [
              {
                geometry:args.geometry
              }
            ]
          })

        });
        setPerimeterSymbology({symbol: symbols.selectedPerimeterSymbol});

      }
      else
      {
        this.enablePerimeterDraw();
        this.setState(
          {
            confirmDisabled: false
          }
        );
      }
    }

    if(geometryField === null)
    {
      this.props.onToolbarEditInactive();
    }
    else
    {
      this.props.onToolbarEditActive();
    }
  }

  cancelOriginEdit = () => {
    this.setGeometryFieldState(null);

    disableDrawMode();
    setOriginSelectionGraphics({
      clearExisting: true,
      graphics: [this.props.incident],
      useDisabledSymbol: false
    });
    this.props.onCancelOriginEdit();
  }

  cancelPerimeterEdit = () => {

    disableDrawMode();

    setModifiedPerimeter({
      graphics: [
        {
          geometry: this.props.originalPerimeterGeometry
        }
      ]
    })

  setPerimeterSymbology({symbol: symbols.selectedPerimeterSymbol});

   //this.props.onCancelPerimeterEdit();
   //this.stopWatchingPerimeterUpdates();
  }

  confirmOriginEdit = () => {
    this.setGeometryFieldState(null);
    disableDrawMode();
    this.props.onConfirmOriginEdit({geometry: this.originGeometry});
  }

  onUploadPerimeter = (shapefilePerimeter) =>
  {
    esriLoader.loadModules(['esri/geometry/support/jsonUtils'])
        .then(([geometryJsonUtils]) => {

          clearModifiedPerimeter();
          clearVisiblePerimeters();

          const perimeter = geometryJsonUtils.fromJSON(shapefilePerimeter);

          //Zoom to new perimeter
          setMapViewTarget({
            target: perimeter
          })

          //Set modified perimeter graphic
          setModifiedPerimeter({
          graphics: [
              {
                geometry: perimeter
              }
            ]
          });

          disableDrawMode();
          setUploadPolygonGeometry(perimeter).then(resp => {
              setPerimeterSymbology({symbol: symbols.selectedPerimeterSymbol});
              this.setState({ confirmDisabled: false});
             this.props.onPerimeterUploaded(perimeter);
         });


        });

  /*esriLoader.loadModules(['esri/geometry/support/jsonUtils'])
      .then(([geometryJsonUtils]) => {
        const perimeter = geometryJsonUtils.fromJSON(shapefilePerimeter);
      this.setGeometryFieldState(null);
      this.props.onConfirmPerimeterEdit({geometry: perimeter});

      setModifiedPerimeter({
      graphics: [
          {
            geometry: perimeter
          }
        ]
      });
    }); */
  }

  confirmPerimeterEdit = () => {
    this.setGeometryFieldState(null);

    if (this.state.modifiedPerimeterGeometry !== null)
    {
      setModifiedPerimeter({
        graphics: [
          {
            geometry:this.state.modifiedPerimeterGeometry
          }
        ]
      })

      this.props.onConfirmPerimeterEdit({geometry: this.state.modifiedPerimeterGeometry});
    }
    else
    {
      completeDrawUpdate().then(geometry =>
        {
          setModifiedPerimeter({
            graphics: [
              {
                geometry:geometry
              }
            ]
          })

          this.props.onConfirmPerimeterEdit({geometry: geometry});
      });
    }

    /*getDrawPolygonGeometry().then( result => {
      result.geometry.type = 'polygon'
      this.props.onConfirmPerimeterEdit({geometry: result.geometry});

      setModifiedPerimeter({
        graphics: [
          {
            geometry:result.geometry
          }
        ]
      })
    }); */
  }

  enableOriginDraw()  {
    this.stopWatchingPerimeterUpdates();

      enableDrawMode({drawAction: "point"})
          .then((args) => {
        this.originGeometry = args.geometry;

        isOriginWithinPerimeter(this.props.perimeter, args.geometry).then(
        result =>
          {
            this.setState ({
              originWithinPerimeter: result
            });
          });

        setOriginSelectionGraphics({
          clearExisting: true,
          graphics: [{
            attributes: null,
            geometry: args.geometry
          }]
        }).then( () => {
            this.setState({ confirmDisabled: false});
        });


        esriLoader.loadModules(['esri/geometry/Point'])
        .then( ([Point]) =>
        {
          var point = new Point(args.geometry);
          this.setState(
            {
              latitude: point.latitude,
              longitude: point.longitude
            }
        );
      });

        this.enableOriginDraw();
      });

  }

  enablePerimeterDraw() {
    enableDrawMode({drawAction: "polygon", geometry: (this.props.perimeter) ? this.props.perimeter.geometry : null} );
  }

  clearPerimeter() {

    completeDrawUpdate().then(geometry =>
      {
        clearModifiedPerimeter();
        clearVisiblePerimeters();

        enableDrawMode({drawAction: "polygon", geometry: null, enableSketchOnDrawComplete: true}).then((args) =>
        {
          this.setState(
            {
              confirmDisabled: false,
              modifiedPerimeterGeometry: args.geometry
            }
          );

          setModifiedPerimeter({
            graphics: [
              {
                geometry:args.geometry
              }
            ]
          })

        });
    });


  }

  activatePerimeterDraw() {
    resumeDrawMode();
    this.startWatchingPerimeterUpdates();
  }

  deactivatePerimeterDraw() {
    pauseDrawMode();
  }

    startWatchingPerimeterUpdates() {
    /*if(!this.handlePerimeterUpdates) {
      onDrawGeometryUpdated(this.onPerimeterUpdated);
    }*/
  }

  manualPointUpdated =  (newPoint) =>
  {
    esriLoader.loadModules(['esri/geometry/support/webMercatorUtils'])
    .then( ([webMercatorUtils]) =>
    {
      this.setState(
        {
          latitude: newPoint.latitude,
          longitude: newPoint.longitude
        }
      );

      let mercatorPoint = webMercatorUtils.geographicToWebMercator(newPoint);
      let mercatorJson = mercatorPoint.toJSON();

      isOriginWithinPerimeter(this.props.perimeter, mercatorPoint).then(
      result =>
        {
          this.setState ({
            originWithinPerimeter: result
          });
        });


      this.originGeometry = mercatorJson;

      setOriginSelectionGraphics({
        clearExisting: true,
        graphics: [{
          attributes: null,
          geometry: mercatorJson
        }]
      }).then( () => {
          this.setState({ confirmDisabled: false});
      });

    });
	}

  stopWatchingPerimeterUpdates() {
    if (this.handlePerimeterUpdates) {
      this.handlePerimeterUpdates.remove();
      delete this.handlePerimeterUpdates;
    }
  }

onPerimeterUpdated = (args, handle) => {
    this.handlePointOfOriginUpdates = handle;
    this.setState({ confirmDisabled: false});
  }

  render() {
    let selectorEl;
    let editOriginEl;
    let editPerimeterEl;

    switch (this.state.geometryField) {
      case null:
        selectorEl = (
          <Paper key="SELECTOR" className="edit-geometry-container edit-geometry-selector" zDepth={2} style={paperStyle} id="EditGeometryToolbarAnchorEl">
            <FlatButton
              label="Edit Origin"
              id="EditOriginButtonAnchorEl"
              icon={<OriginIcon />}
              onClick={() => {
                this.setGeometryFieldState("ORIGIN")
              }} />
              <span>
            <FlatButton
              disabled={!this.props.incident.perimeter.CanAddNewPerimeter}
              label={ (!this.props.perimeter) ? "Create Perimeter" : "Edit Perimeter"}
              icon={<PerimeterIcon />}
              onClick={() => {
                this.setGeometryFieldState("PERIMETER")
              }} />
              </span>
          </Paper>
        )
        break;
      case "ORIGIN":
        editOriginEl = (
          <EditOriginToolbar
           key="ORIGIN"
           incident={this.props.incident}
           latitude={this.state.latitude}
           longitude={this.state.longitude}
           originWithinPerimeter={this.state.originWithinPerimeter}
           onUpdatePoint={debounce((point) => {
           this.manualPointUpdated(point)
         },300)}
           onConfirmOriginEdit={this.confirmOriginEdit.bind(this)}
           onCancelOriginEdit={this.cancelOriginEdit.bind(this)}
                confirmDisabled={this.state.confirmDisabled}
           />
        )
        break;
      case "PERIMETER":
        editPerimeterEl = (
          <EditPerimeterToolbar
           key="PERIMETER"
           onClearPerimeter={this.clearPerimeter.bind(this)}
           onConfirmPerimeterEdit={this.confirmPerimeterEdit.bind(this)}
           onCancelPerimeterEdit={this.cancelPerimeterEdit.bind(this)}
           onUploadPerimeter={this.onUploadPerimeter.bind(this)}
           onActivate={this.activatePerimeterDraw.bind(this)}
           onDeactivate={this.deactivatePerimeterDraw}
           confirmDisabled={this.state.confirmDisabled}
           />
        )
        break;
      default:

    }

    return ReactDOM.createPortal(
      (
        <CSSTransitionGroup
          transitionName="edit-geometry-toolbar"
          transitionEnterTimeout={325}
          transitionLeaveTimeout={325} >
          {selectorEl}
          {editPerimeterEl}
          {editOriginEl}
        </CSSTransitionGroup>
      ),
      document.getElementById("editPerimeterAnchorEl")
    );
  }
}



export default EditGeometryToolbar;
